import React from 'react';
import { Box, StepLabel, Step, Stepper } from '@mui/material';
import styles from './styles';

const steps = ['Investment Strategy', 'Timeline', 'Price Range', 'Personal Info'];

const Header = ({ activeStep }: { activeStep: number }) => {
  return (
    <Box sx={{ ...styles.contentBox, minHeight: '60px', borderBottom: '1px solid #E0E0E0' }}>
      <Stepper activeStep={activeStep} alternativeLabel sx={{width: '90%', mb: 2}}>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default Header;
